import { render, staticRenderFns } from "./login-as-tenant.vue?vue&type=template&id=1f48e980&scoped=true&"
import script from "./login-as-tenant.vue?vue&type=script&lang=js&"
export * from "./login-as-tenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48e980",
  null
  
)

export default component.exports